<template>
  <div class="detail-page" v-if="baseInfo">
      <div style="left:10000px; width: 0px; height: 0px; overflow: hidden; position: fixed;">
        <canvas id="shareImage" style="height: 200px;width: 250px"></canvas>
      </div>
    <banner
        :image="baseInfo.image"
        :title="baseInfo.head && baseInfo.head.title"
        :status="baseInfo.status"
        :prdTmpId="baseInfo.prdTmpId"
        :destinationName="baseInfo.destinationName"
        :isApp="baseInfo.isApp"
        :newLineTypeName="baseInfo.newLineTypeName"
        :supportGroupBuying="supportGroupBuying"
        :groupActivity="groupActivity"
        :classBrandId="baseInfo.classBrandId"
        :saleEmpty="baseInfo.head.saleEmpty"
    ></banner>
    <div class="detail-content">
        <brief
            :baseData="baseInfo.head"
            :prdTmpId="baseInfo.prdTmpId"
            :startPrice="startPrice"
            :baseInfo="baseInfo"
            :status="baseInfo.status"
            :blackCard="baseInfo.otherInfo && baseInfo.otherInfo.activity"
            :supportGroupBuying="supportGroupBuying"
            :groupActivity="groupActivity"
        ></brief>
        <recommend-products v-if="baseInfo.status == 1 && baseInfo.head.saleEmpty == 1" :baseData="baseInfo.crossRecommendPrdList"
        ></recommend-products>
        <group-list
            :supportGroupBuying="supportGroupBuying"
            :groupActivity="groupActivity"
            :status="baseInfo.status"
            v-if="supportGroupBuying"
        ></group-list>
        <group-rule
            v-if="supportGroupBuying"
            :prdTmpId="baseInfo.prdTmpId"
        ></group-rule>
        <share-poster
            v-if="baseInfo.posterUrl && showAllBtnAndPoster"
            :shareImageData.sync="shareImageData"
        ></share-poster>
        <other-info
            :baseData="otherInfoList"
            :isApp="baseInfo.isApp"
            :prdTmpId="baseInfo.prdTmpId"
            :image="baseInfo.image"
            :head="baseInfo.head"
            :productId="baseInfo.productId"
            :timeDifference="baseInfo.timeDifference"
            :packageNum="baseInfo.packageNum"
            :packageData="baseInfo.packageInfo"
            :agencyType="baseInfo.otherInfo.shop.agencyType"
            :isHideShop="isHideShop"
            @openPackagePopup="openPackagePopup"
            v-if="baseInfo.status == 1"
        ></other-info>

        <tab-view
            :tabList="baseInfo.bodyTitle"
            :detailData="baseInfo.productDetail"
            :packageData="baseInfo.packageInfo"
            :journeyData="baseInfo.journeyInfos"
            :reserveNotice="baseInfo.purchaseNotes.reserveNotice"
            :purchaseNotes="baseInfo.purchaseNotes"
            :backRule="baseInfo.backRule"
            :crossRecommend="baseInfo.crossRecommendPrdList"
            :prdTmpId="baseInfo.prdTmpId"
            :isApp="baseInfo.isApp"
            v-if="baseInfo.status == 1 && Array.isArray(baseInfo.bodyTitle) && baseInfo.bodyTitle.length"
        ></tab-view>

        <recommend-products v-if="baseInfo.status == 1 && baseInfo.head.saleEmpty == 0"
            :baseData="baseInfo.crossRecommendPrdList"
        ></recommend-products>

        <!-- hide plane ticket for "定制师服务" -->
        <plane-ticket
            v-if="baseInfo.prdTmpId != 6"
            :baseInfo="baseInfo"
            :isApp="baseInfo.isApp"
            :isTekApp="baseInfo.isTekApp"
        ></plane-ticket>

        <div class="type-title" v-if="baseInfo.status == 1"><i></i>让旅游更简单<i></i></div>

        <side-tool v-if="baseInfo.status == 1"></side-tool>

        <bottom-bar
            :shop="baseInfo.otherInfo && baseInfo.otherInfo.shop"
            :collected="baseInfo.collected"
            :isApp="baseInfo.isApp"
            :startPrice="startPrice"
            :prdTmpId="baseInfo.prdTmpId"
            :productId="baseInfo.productId"
            :status="baseInfo.status"
            @openPackagePopup="openPackagePopup"
            :supportGroupBuying="supportGroupBuying"
            :groupActivity="groupActivity"
            :isGroupBuying.sync="isGroupBuying"
            :showAllBtnAndPoster.sync="showAllBtnAndPoster"
            :shareImageData.sync="shareImageData"
            :isHideShop="isHideShop"
        ></bottom-bar>
        <package-popup
            v-if="baseInfo.status == 1 && (baseInfo.prdTmpId && baseInfo.prdTmpId === 3 || baseInfo.groupActivity)"
            :show="showPackagePopup"
            :image="baseInfo.image"
            :head="baseInfo.head"
            :productId="baseInfo.productId"
            :isGroupBuying="isGroupBuying"
            :groupActivity="groupActivity"
            :showAllBtnAndPoster.sync="showAllBtnAndPoster"
        ></package-popup>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Popup from '@/components/Popup';
import detailStoreModule from '../store/modules/detail';
import derivativePackageStoreModule from '../store/modules/derivativePackage';
import Banner from '@/components/detail/Banner';
import Brief from '@/components/detail/Brief';
import OtherInfo from '@/components/detail/OtherInfo';
import RecommendProducts from '@/components/detail/recommend';
import TabView from '@/components/detail/tabView/Index';
import PlaneTicket from '@/components/detail/PlaneTicket';
import BottomBar from '@/components/detail/BottomBar';
import PackagePopup from '@/components/PackagePopup';
import SideTool from '@/components/detail/tabView/SideTool';
import groupList from '@/components/detail/groupBuying/groupList';
import groupRule from '@/components/detail/groupBuying/groupRule';
import sharePoster from '@/components/detail/sharePoster';
import { updateTopBar } from '@/business/tkd';
import { setShareInfoOnWX, setShareInfoOnApp } from '@/business/wx';
import { pageTrack } from '@/business/analy';
import shareConfig from '../util/shareConfig';
const { resizeImage } = require('@tuniu/light-helper');
import { subtract } from "../util/math"

export default {
    name: 'detail',
    asyncData ({ store, route, cookies, userAgent }) {
        if (!store.state.detail) {
            store.registerModule('detail', detailStoreModule);
            return store.dispatch('detail/getBaseInfo', {
                productId: route.params.id,
                cookies,
                userAgent
            }).then(data => {
                store.dispatch('changeStartPrice', { startPrice: data && data.head && data.head.price && data.head.price.startPrice })
                if (data.status == 1 && (data.prdTmpId == 3 || data.groupActivity) && !store.state.derivativePackage) {
                    store.registerModule('derivativePackage', derivativePackageStoreModule);
                    return store.dispatch('derivativePackage/getPackageList', {
                        prdTmpId: data.prdTmpId,
                        productId: data.productId,
                        cookies,
                        userAgent
                    });
                }
            });
        }
    },
    created () {
        if (typeof window !== 'undefined') {
            if (this.baseInfo.status !== 1) {
                location.href = location.origin;
            }
            if (!this.$store.getters['detail/productId']) {
                this.$store.registerModule('detail', detailStoreModule, {preserveState: true});
            }
            if (this.baseInfo.status == 1 && (this.baseInfo.prdTmpId == 3 || this.baseInfo.groupActivity) && !this.$store.getters['derivativePackage/groupPackageList']) {
                this.$store.registerModule('derivativePackage', derivativePackageStoreModule, {preserveState: true});
            }
            let travelCount = this.supportGroupBuying ? this.baseInfo.head.count.saleCount : this.baseInfo.head.count.travelCount;
            let satisfaction = this.baseInfo.otherInfo.remark.remarkSatisfaction;
            if (travelCount > 0 && satisfaction === 0) {
              satisfaction = 100;
            }
            let dataDict = {
              convasKeyId: 'shareImage',
              imageUrl: resizeImage(this.baseInfo.image.productImageList[0].imageUrl, 640, 320, 1),
              cityName: this.baseInfo.destinationName,
              productTypeName: this.baseInfo.classBrandParentName,
              startPrice: this.supportGroupBuying ? this.groupStartPrice : this.startPrice,
              promotionPrice: this.supportGroupBuying ? subtract(this.startPrice, this.groupStartPrice) : null,
              satisfaction,
              travelCount,
              isDerivative: this.baseInfo.prdTmpId === 3
            }
            shareConfig.generateLocalImage(dataDict, localData=>{
              this.shareImageData = {'imageData':localData.replace('data:image/png;base64,', ''),'productId':this.baseInfo.productId};
            })
        }
    },
    beforeMount() {
        updateTopBar('产品详情');
    },
    mounted () {
        let isApp = this.baseInfo && this.baseInfo.isApp;
        if (this.baseInfo && this.baseInfo.classBrandId) {
            localStorage.setItem('classBrandId',this.baseInfo.classBrandId);
        }
        if (isApp) {
            setShareInfoOnApp(this.baseInfo);
        } else {
            setShareInfoOnWX(this.baseInfo);
        }
        this.track();
        if (window.PERFORMANCE && window.elkStartTime) {
            window.PERFORMANCE.r = new Date().getTime() - window.elkStartTime;
        }
        console.log(this.getCookie('tuniu_partner'));
        console.log(this.getCookie('thirdPartyUserInfo'))
        if(this.getCookie('thirdPartyUserInfo') && JSON.parse(atob(this.getCookie('thirdPartyUserInfo')))){
           let pValue = JSON.parse(atob(this.getCookie('thirdPartyUserInfo'))).p;
           console.log(pValue)
            this.isHideShop = pValue == 75647 ? true :false;
          

        }
       
    },
    components: {
        Banner,
        Brief,
        OtherInfo,
        RecommendProducts,
        TabView,
        PlaneTicket,
        BottomBar,
        Popup,
        PackagePopup,
        SideTool,
        groupList,
        groupRule,
        sharePoster
    },
    data () {
        return {
            showPackagePopup: {isShow: false},
            isGroupBuying: false, //是否为拼团订单
            shareImageData: {},
            isHideShop:false,
        }
    },
    computed: {
        ...mapState({
            baseInfo: state => state.detail && state.detail.baseInfo,
            startPrice: state => state.startPrice
        }),
        ...mapGetters('derivativePackage', [
            'groupStartPrice'
        ]),
        otherInfoList () {
            if (this.$store.state.detail && this.$store.state.detail.baseInfo && this.$store.state.detail.baseInfo.otherInfo) {
                let otherInfoList = [];
                let otherInfo = this.$store.state.detail.baseInfo.otherInfo;
                for(let key in otherInfo){
                    if (otherInfo.hasOwnProperty(key)){
                         otherInfoList.push(otherInfo[key] ? otherInfo[key] : {name: key})
                    }
                }
                otherInfoList.sort((a, b) => {
                    return a.order - b.order;
                })
                return otherInfoList;
            } else {
                return [];
            }
        },
        groupActivity () {
            return this.baseInfo.groupActivity
        },
        supportGroupBuying () {
            return !!this.groupActivity
        },
        showAllBtnAndPoster () {
            let { isTekApp, ownerType, shopType } = this.baseInfo;
            return isTekApp && (ownerType == 2 || ownerType == 3 || (ownerType == 4 && shopType == 3));
        }
    },
    watch: {
        '$route' (to) {
            if (to.params.id !== this.$route.params.id) {
                this.$store.dispatch('detail/getBaseInfo', {
                    productId: to.params.id
                }).then(data => {
                    store.dispatch('changeStartPrice', { startPrice: data && data.head && data.head.price && data.head.price.startPrice })
                })
            }
        }
    },
    destroyed () {
        // this.$store.unregisterModule('detail')
    },
    methods: {
        track() {
            let shopId = (this.baseInfo && this.baseInfo.otherInfo && this.baseInfo.otherInfo.shop && this.baseInfo.otherInfo.shop.shopId) || 0;
            if (!shopId) {
                return;
            }
            let trackData = [
                '无线',
                '产品详情',
                '平台=零售平台',
                '商户id=' + shopId,
                '产品编号=' + (this.baseInfo && this.baseInfo.productId),
                '品类=' + (this.baseInfo && this.baseInfo.classBrandParentName),
                '二级品类=' + (this.baseInfo && this.baseInfo.classBrandName),
                '目的地=' + (this.baseInfo && this.baseInfo.newLineTypeName),
                '一级目的地分组=' + (this.baseInfo && this.baseInfo.parentDestName),
                '二级目的地分组=' + (this.baseInfo && this.baseInfo.subDestName),
                '售卖形式=' + (this.baseInfo && this.baseInfo.head && this.baseInfo.head.saleForm)
            ];
            pageTrack(trackData);
        },
        openPackagePopup () {
            this.showPackagePopup.isShow = true;
        },
        getCookie (objName) {
            var arrStr = document.cookie.split("; ");
            for (var i = 0; i < arrStr.length; i++) {
                var temp = arrStr[i].split("=");
                if (temp[0] == objName) return unescape(temp[1]);
            }
        },
    }
}
</script>

<style lang="scss">
.detail-page {
    padding-bottom: 56px;
    .sale-out {
        .product-name {
            padding: 12px;
            font-size: 16px;
            color: #000000;
            line-height: 22px;
            font-weight: 600;
        }
        .product-type {
            padding: 12px;
            font-size: 15px;
            color: #A5A5A5;
            line-height: 16px;
        }
        .next-order {
            opacity: .5;
        }
        .sale-out-cont {
            width: 100%;
            height: 30px;
            text-align: center;
            line-height: 30px;
            position: fixed;
            bottom: 48px;
            background: rgba(76,90,101,0.40);
            font-size: 14px;
            color: #fff;
        }
    }
    .type-title {
        height: 45px;
        text-align: center;
        font-size: 13px;
        color: #a5a5a5;
        line-height: 45px;
        width: 100%;
        position: relative;
        i:first-child {
            margin-right: 20px;
            position: relative;
            &:before {
                content: "";
                position: absolute;
                top: 50%;
                right: 0;
                transform: translateY(-50%);
                width: 22px;
                height: 1px;
                background: #dadada;
            }
            &:after {
                content: "";
                position: absolute;
                top: 50%;
                left: 2px;
                transform: translateY(-50%);
                width: 1px;
                height: 1px;
                background: #dadada;
            }
        }
        i:last-child {
            margin-left: 20px;
            position: relative;
            &:before {
                content: "";
                position: absolute;
                top: 50%;
                right: 2px;
                transform: translateY(-50%);
                width: 1px;
                height: 1px;
                background: #dadada;
            }
            &:after {
                content: "";
                position: absolute;
                top: 50%;
                left: 0;
                transform: translateY(-50%);
                width: 22px;
                height: 1px;
                background: #dadada;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// Detail.vue